import React, { useRef, useEffect } from 'react'
import { gsap } from 'gsap' 
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import './title.css'

function Title({title, id}) {

    const sectionTitle = useRef(null)

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger)
        sectionTitle.current.innerHTML = sectionTitle.current.textContent.replace(/\S/g, "<span class='letter'>$&</span>")
        gsap.from(`#${id} span`, {
           duration: 0.8,
           opacity: 0,
           delay: 0.5,
           ease: "power4.out",
           y: 50,
           scrollTrigger: {
            trigger: `#${id}`
           },
           stagger: {
             amount: 1
           },
        })
    }, [id])

  return (
    <div className="container-fluid">
       <div key={id} className='section-title'>
            <h2 id={id} ref={sectionTitle} className='serif'>
                {title}
            </h2>
        </div>
    </div>
  )
}

export default Title